import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { t } from "@/lib/i18n";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.needs_onboarding ? "/onboarding" : "/dashboard", { replace: true });
      } catch {
        setError("Autenticazione Google non riuscita. Riprova.");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen app-soft-bg flex flex-col items-center justify-center gap-4 text-foreground">
      <Loader2 className="h-10 w-10 animate-spin text-primary" />
      <p className="text-muted-foreground">{error || t("Accesso in corso…")}</p>
    </div>
  );
}
